import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';

const assignedToMapper = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  return {
    normalizableCollectionFilters: [
      {
        column: 'AssignedTo',
        values: [appliedFilter.criterionArgumentValue],
        isIn: criteria.isIn,
        isNull: criteria.isNull,
      },
    ],
  };
};

export default assignedToMapper;
